<template>
  <!-- 
    @close="closeSetting" -->
  <el-dialog
    :visible.sync="dialogVisible"
    :before-close="handleClose"
    class="custom-dialog"
    top="calc(50vh - 310px)"
    custom-class="custom"
    width="708px"
    center
  >
    <div slot="title" class="dialog-title tabheader">偏好设置</div>
    <div class="custom-tab">
      <span
        :class="['item', { on: tab.id === currentTab }]"
        v-for="tab in tabs"
        :key="tab.id"
        data-io-click="tracker"  @click="changeTab(tab.id)"
        ><i :class="['iconfont', tab.icon]"></i>{{ tab.name }}</span
      >
    </div>
    <div class="custom-modules">
      <div class="module" v-if="currentTab === 1">
        <div class="loading" v-if="isLoadingFeatures">正在加载中...</div>
        <template v-else>
          <h5 class="title">选择需要开启的功能</h5>
          <div class="info">
            开启后，应用左侧将增加该功能，同时可以设置默认首页和显示顺序。
          </div>
          <div class="features">
            <!-- href="javascript:void(0);" -->
            <div v-for="(feature, index) in features" :key="feature.functionId">
              <a
                href="javascript:;"
                :class="[
                  'feature-item',
                  { 'drop-in': dragOverId === feature.functionId },
                ]"
                :data-index="index"
                :draggable="true"
                @dragstart="dragstart($event, index, null)"
                @drop.prevent="drop($event, index, null)"
                @dragend.prevent="dragend($event, index)"
                @dragenter.prevent="dragenter($event, index, null)"
                @dragover.prevent="dragover($event, feature, null)"
                @dragleave.prevent="dragleave($event, index)"
              >
                <span class="drag"><i class="iconfont icon-list"></i></span>
                <svg aria-hidden="true" class="icon">
                  <use :xlink:href="'#' + feature.checkedClass"></use>
                </svg>
                <span class="name">{{ feature.functionName }}</span>
                <span class="tip" v-if="feature.isDefault === 1">默认首页</span>
                <el-switch
                  v-if="feature.isDefault !== 1 && feature.isMenu"
                  v-model="feature.showFlag"
                  :width="50"
                  active-color="#0057FF"
                  inactive-color="#B6B9C0"
                  @change="setDisplay(feature)"
                >
                </el-switch>
                <button
                  class="btn"
                  data-io-click="tracker"  @click.stop.prevent="setDefault(feature)"
                  v-if="feature.isDefault !== 1 && feature.isMenu"
                >
                  设为默认
                </button>
              </a>
              <div
                class="child-menus"
                v-if="feature.childFunctions && feature.childFunctions.length"
              >
                <a
                  href="javascript:;"
                  :class="[
                    'feature-item',
                    'child-feature-item',
                    { 'drop-in': dragOverId === childFeature.functionId },
                  ]"
                  v-for="(childFeature, childIndex) in feature.childFunctions"
                  :data-index="childIndex"
                  :key="childFeature.functionId"
                  :draggable="true"
                  @dragstart="dragstart($event, index, childIndex)"
                  @drop.prevent="drop($event, index, childIndex)"
                  @dragend.prevent="dragend($event, childIndex)"
                  @dragenter.prevent="dragenter($event, index, childIndex)"
                  @dragover.prevent="dragover($event, feature, childFeature)"
                  @dragleave.prevent="dragleave($event, childIndex)"
                >
                  <!-- childFeature.isMenu -->
                  <span class="drag" v-if="childFeature.isMenu"
                    ><i class="iconfont icon-list"></i
                  ></span>
                  <!-- <svg aria-hidden="true" class="icon">
                    <use :xlink:href="'#' + childFeature.checkedClass"></use>
                  </svg> -->
                  <div class="circle"></div>
                  <span class="name">{{ childFeature.functionName }}</span>
                  <span class="tip" v-if="childFeature.isDefault === 1"
                    >默认首页</span
                  >
                  <el-switch
                    v-if="childFeature.isDefault !== 1"
                    v-model="childFeature.showFlag"
                    :width="50"
                    active-color="#0057FF"
                    inactive-color="#B6B9C0"
                    @change="setDisplay(childFeature)"
                  >
                  </el-switch>
                  <button
                    class="btn"
                    data-io-click="tracker"  @click.stop.prevent="setDefault(childFeature)"
                    v-if="childFeature.isDefault !== 1"
                  >
                    设为默认
                  </button>
                </a>
              </div>
            </div>
          </div>
        </template>
      </div>
      <div class="module book-module" v-if="currentTab === 3">
        <h5 class="title">教材信息</h5>
        <!-- <div class="info">至少需要保留一本教材，方便更精准的找到所需资料。</div> -->
        <div class="add-textbook" data-io-click="tracker"  @click="textbook.openTextbookDialog('主动')">
          <svg aria-hidden="true" class="icon">
            <use xlink:href="#icon-addition"></use>
          </svg>
          添加教材
        </div>
        <div class="books" v-if="userTextBook.length > 0">
          <book
            v-for="(item, index) in userTextBook"
            :key="item.id"
            :book="item"
            :index="index"
            @selectBook="clickBook"
            @deleteBookCallback="deleteBookCallback"
          ></book>
        </div>
        <div v-else class="nothing">
          <img src="@/assets/images/none.png" alt="" />
          <div class="tip">暂无教材</div>
        </div>
      </div>
    </div>
  </el-dialog>
</template>
<script>
const tabs = [
  { id: 1, name: "功能", icon: "icon-feature" },
  // { id: 2, name: "搜索", icon: "icon-search-set" },
  { id: 3, name: "教材", icon: "icon-book" },
];
import {
  getFeatures,
  setFeatures,
  getUserModuleAuth,
  updateUserFunctionSort,
} from "@/utils/apis";
import Book from "@/components/Book";
import { mapState } from "vuex";
export default {
  props: {
    dialogVisible: {
      type: Boolean,
      default: false,
    },
    textbooks: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  // computed: {
  //   // 我的教材过滤掉不限

  // },
  watch: {
    currentCourse: {
      handler(val) {
        if (val) {
          this.getFeatures();
        }
      },
      immediate: true,
    },
  },
  inject: ["textbook"],
  data() {
    return {
      tabs,
      currentTab: 1,
      // 是否正在加载功能列表
      isLoadingFeatures: false,
      // 用户功能
      features: [],
      // 作为默认首页的用户功能
      defaultFeature: {},
      // 正在拖拽的index
      dragStartIndex: 0,
      // 放置的index
      dragOverIndex: "",
      // 是否正在提交用户设置
      isSettingFeatures: false,
      draggedItem: null,
      draggedParent: null,
      dragOverChildIndex: null,
      dragOverId: null,
    };
  },
  computed: {
    ...mapState(["currentCourse"]),
    userTextBook() {
      if (this.textbook.textbooks.length) {
        return this.textbook.textbooks.filter(
          (item) => item.versionName != "不限"
        );
      } else {
        return [];
      }
    },
  },
  mounted() {
    // this.getFeatures();
  },
  components: {
    // 书本
    Book,
  },
  methods: {
    async deleteBookCallback(e) {
      await this.textbook.getUserCourses(false);
      await this.textbook.loadTextbooks();
    },
    async getFeatures() {
      try {
        this.isLoadingFeatures = true;
        const data = await getUserModuleAuth({
          courseId: this.currentCourse.courseId,
        });
        if (
          data.code === 200 &&
          data.result.functionList &&
          data.result.functionList.length
        ) {
          this.features = data.result.functionList;
          let defaultFeature = null;
          // this.defaultFeature = this.features.find(
          //   (feature) => feature.isDefault === 1
          // );
          this.features.forEach((feature) => {
            if (feature.isDefault === 1) {
              defaultFeature = feature;
            } else if (
              feature.childFunctions &&
              feature.childFunctions.length
            ) {
              feature.childFunctions.forEach((child) => {
                if (child.isDefault === 1) {
                  defaultFeature = child;
                }
              });
            }
          });
          this.defaultFeature = defaultFeature;
        }
        this.isLoadingFeatures = false;
      } catch (error) {}
    },
    // 设置用户偏好功能
    async setFeatures(params) {
      if (this.isSettingFeatures) return false;
      this.isSettingFeatures = true;
      // this.features.forEach((feature, index) => {
      //   feature.sort = index + 1;
      // });
      // this.features
      try {
        const data = await updateUserFunctionSort(params);
        if (data.code === 200) {
          this.$emit("setFeaturesSuccess");
        }
      } catch (error) {}
      this.isSettingFeatures = false;
    },
    // 左侧tab切换
    changeTab(id) {
      this.currentTab = id;
    },
    deleteBook(bookId) {
      this.$emit("deleteBook", bookId);
    },
    // 设为默认
    async setDefault(feature) {
      console.log("feature", feature);
      this.features.forEach((item) => {
        item.isDefault = 0;
        if (item.childFunctions && item.childFunctions.length) {
          item.childFunctions.forEach((child) => {
            child.isDefault = 0;
          });
        }
      });
      let params = [
        {
          functionId: feature.functionId,
          isDefault: 1,
          showFlag: true,
        },
      ];
      this.$set(feature, "isDefault", 1);
      this.$set(feature, "showFlag", true);
      await this.setFeatures(params);
      this.defaultFeature = feature;
      return false;
    },
    // 设置是否显示
    setDisplay(feature) {
      console.log("feature", feature);
      if (!feature.showFlag && feature.redirectUrl === this.$route.path) {
        this.$router.push({
          path: this.defaultFeature.redirectUrl,
        });
      }
      let params = [
        {
          functionId: feature.functionId,
          isDefault: feature.isDefault,
          showFlag: feature.showFlag,
        },
      ];
      this.setFeatures(params);
    },
    // 拖拽
    dragstart(event, parentIndex, index) {
      console.log("event, parentIndex,index", parentIndex, index);
      this.dragStartIndex = index;
      this.dragParentIndex = parentIndex;
      this.draggedParent = parent;
      this.draggedItem =
        index === null
          ? this.features[parentIndex]
          : this.features[parentIndex].childFunctions[index];
      event.dataTransfer.effectAllowed = "move";
    },
    dragend(event, index) {
      this.dragOverId = null;
      // this.dragOverChildIndex = null
    },
    dragenter(event, index, childIndex = null) {
      // console.log('event, index, childIndex', index, childIndex)
      // this.dragOverIndex = index;
      // this.dragOverChildIndex = childIndex;
      // console.log('dragOverIndex',this.dragOverIndex,this.dragOverChildIndex)
      event.preventDefault();
    },
    dragover(event, parent, item) {
      console.log("event, parent, item", parent, item);
      // console.log('---parent',parent,this.draggedParent)
      // event.dataTransfer.dropEffect = "move";
      // if (this.draggedParent === parent) {
      // this.dragOverIndex = index;
      // this.dragOverChildIndex = childIndex;
      this.dragOverId = item ? item.functionId : parent.functionId;
      event.dataTransfer.dropEffect = "move";
      // } else {
      //   event.dataTransfer.dropEffect = "none";
      // }
      event.preventDefault();
    },
    dragleave(event, index) {
      event.preventDefault();
    },
    // 放下
    drop(event, parentIndex, index) {
      if (this.dragStartIndex === null) {
        this.features.splice(this.dragParentIndex, 1);
        this.features.splice(parentIndex, 0, this.draggedItem);
      } else {
        const children = this.features[parentIndex].childFunctions;
        children.splice(this.dragStartIndex, 1);
        children.splice(index, 0, this.draggedItem);
      }
      this.draggedItem = null;
      this.draggedParent = null;
      this.dragParentIndex = null;
      console.log("设置偏好");
      this.features.forEach((feature, index) => {
        feature.sort = index + 1;
      });
      this.setFeatures(this.features);
      event.preventDefault();
      event.stopPropagation();
    },
    handleClose() {
      this.$emit("closeModal");
    },
    clickBook(book) {
      this.textbook.toTechByTextbook(book);
      this.handleClose();
    },
  },
};
</script>
<style scoped lang="scss">
::v-deep .custom {
  height: 665px;
  font-size: 14px;
  .el-dialog__body {
    position: relative;
  }
}
::v-deep .el-dialog__header {
  text-align: left;
}
.custom-tab {
  padding-top: 6px;
  position: absolute;
  width: 163px;
  height: calc(100% - 58px);
  border-right: 1px solid #e6e7e9;
  .item {
    position: relative;
    margin-top: 10px;
    display: block;
    text-align: center;
    height: 50px;
    line-height: 50px;
    cursor: pointer;
    &:before {
      position: absolute;
      top: 15px;
      width: 6px;
      height: 20px;
      left: -6px;
      background: #0057ff;
      border-radius: 0px 30px 30px 0px;
      content: "";
      transition: all 0.2s;
    }
    .iconfont {
      margin-right: 8px;
      font-size: 14px;
      color: #80848b;
    }
    &:hover,
    &.on {
      background: #f6f7f9;
      color: #0057ff;
      .iconfont {
        color: #0057ff;
      }
      &:before {
        left: 0;
      }
    }
  }
}
.custom-modules {
  padding-left: 163px;
  .title {
    text-align: left;
    padding-left: 24px;
    margin-top: 22px;
    font-size: 14px;
    color: #333;
    line-height: 14px;
  }
  .info {
    text-align: left;
    padding-left: 24px;
    display: block;
    margin-top: 10px;
    font-size: 14px;
    color: #80848b;
    line-height: 14px;
  }
  .features {
    padding-top: 8px;
    height: 548px;
    overflow-y: scroll;
    &::-webkit-scrollbar {
      //设置滚动条宽高
      display: none;
    }
    .feature-item {
      display: block;
      position: relative;
      padding: 24px 22px 24px 43px;
      height: 74px;
      &:before {
        position: absolute;
        left: 24px;
        bottom: -1px;
        right: 0;
        height: 1px;
        background: #e6e7e9;
        content: "";
      }
      &.drop-in {
        background: #e6e7e9;
      }
      &.child-feature-item {
        padding-left: 74px;
      }
      .drag {
        position: absolute;
        left: 10px;
        top: 28px;
        cursor: pointer;
        opacity: 0;
        transition: all 0.2s;
        .iconfont {
          color: #669aff;
        }
      }
      .btn {
        float: right;
        margin-right: 20px;
        width: 78px;
        height: 26px;
        line-height: 24px;
        border-radius: 21px;
        border: 1px solid #80848b;
        text-align: center;
        font-size: 14px;
        color: #80848b;
        cursor: pointer;
        &:hover,
        &.on {
          background: #e5f7fe;
          border-color: #0057ff;
          color: #0057ff;
        }
      }
      .icon {
        float: left;
        margin-right: 12px;
        margin-top: 2px;
        width: 22px;
        height: 22px;
      }
      .circle {
        width: 4px;
        height: 4px;
        border-radius: 50%;
        display: inline-block;
        background: #333;
        float: left;
        margin-top: 11px;
        margin-right: 4px;
      }
      .name {
        float: left;
        line-height: 26px;
        font-size: 14px;
        color: #333;
      }
      .tip {
        margin-left: 16px;
        float: left;
        font-size: 12px;
        color: #669aff;
        line-height: 26px;
      }
      ::v-deep .el-switch {
        float: right;
        line-height: 26px;
        height: 26px;
        .el-switch__core {
          width: 50px;
          height: 26px;
          border-radius: 14px;
          &:after {
            top: 1px;
            width: 22px;
            height: 22px;
          }
        }
        &.is-checked .el-switch__core {
          &:after {
            margin-left: -23px;
          }
        }
      }
      &:hover {
        background: #ffffff;
        box-shadow: 0px 1px 6px 0px rgba(0, 0, 0, 0.12);
        z-index: 10;
        .circle {
          background: #0057ff;
        }
        .name {
          color: #0057ff;
        }
        &:before {
          display: none;
        }
        .drag {
          opacity: 1;
        }
      }
    }
  }
  .book-module {
    position: relative;
    .add-textbook {
      position: absolute;
      top: 0;
      right: 22px;
      line-height: 14px;
      cursor: pointer;
    }
  }
  .books {
    padding-top: 24px;
    text-align: left;
    height: 530px;
    overflow-y: auto;
    overflow-x: hidden;
    ::v-deep .book {
      margin-bottom: 17px;
    }
  }
  .nothing {
    text-align: center;
    margin-top: 100px;
    img {
      width: 100px;
      height: auto;
    }
    .tip {
      margin-top: 20px;
    }
  }
}
</style>
<style lang="scss">
.custom-dialog {
  .custom {
    transform: none;
    top: 0;
  }
}
</style>
